import React from "react";

const logoIcon = props => (
  <div>
    <img src={props.url} alt={props.alt} className={props.className} />
  </div>
);

export default logoIcon;
